<template>
  <Icon>
    <svg
      slot="svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 196 129.02">
      <defs/>
      <g
        id="Warstwa_2"
        data-name="Warstwa 2">
        <g
          id="Warstwa_1-2"
          data-name="Warstwa 1">
          <circle
            class="cls-1"
            cx="5.95"
            cy="75.49"
            r="5.95
          "/>
          <circle
            class="cls-1"
            cx="5.95"
            cy="98.29"
            r="5.95"
          />
          <circle
            class="cls-1"
            cx="28.72"
            cy="52.69"
            r="6.24"
          />
          <circle
            class="cls-2"
            cx="28.72"
            cy="75.49"
            r="6.24"
          />
          <circle
            class="cls-2"
            cx="28.72"
            cy="98.29"
            r="6.24"
          />
          <circle
            class="cls-1"
            cx="28.72"
            cy="121.09"
            r="6.52"
          />
          <circle
            class="cls-1"
            cx="51.5"
            cy="29.89"
            r="6.52"
          />
          <circle
            class="cls-2"
            cx="51.5"
            cy="52.69"
            r="6.52"
          />
          <circle
            class="cls-2"
            cx="51.5"
            cy="121.09"
            r="6.8"
          />
          <circle
            class="cls-1"
            cx="74.27"
            cy="7.09"
            r="6.8"
          />
          <circle
            class="cls-2"
            cx="74.27"
            cy="29.89"
            r="6.8"
          />
          <circle
            class="cls-3"
            cx="74.27"
            cy="121.09"
            r="7.09"
          />
          <circle
            class="cls-2"
            cx="97.04"
            cy="7.09"
            r="7.09"
          />
          <circle
            class="cls-3"
            cx="97.04"
            cy="121.09"
            r="7.37"
          />
          <circle
            class="cls-3"
            cx="119.81"
            cy="14.69"
            r="7.37"
          />
          <circle
            class="cls-4"
            cx="120.81"
            cy="121.09"
            r="7.65"
          />
          <circle
            class="cls-4"
            cx="145.09"
            cy="121.09"
            r="7.94"
          />
          <circle
            class="cls-4"
            cx="171.47"
            cy="56.62"
            r="8.22"
          />
          <circle
            class="cls-4"
            cx="167.87"
            cy="113.49"
            r="8.22"
          />
          <circle
            class="cls-4"
            cx="185.49"
            cy="75.49"
            r="8.5"
          />
          <circle
            class="cls-4"
            cx="148.21"
            cy="50.65"
            r="7.94"
          />
          <circle
            class="cls-3"
            cx="130.81"
            cy="34.75"
            r="7.65"
          />
          <circle
            class="cls-4"
            cx="185.49"
            cy="98.29"
            r="8.5"
          />
        </g>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from "./icon";

export default {
  name: 'DsPartialLogoIcon',
  components: {
    Icon
  }
};
</script>

<style lang="scss" scoped>
.cls-1 {
  fill: #f6921e;
}
.cls-2 {
  fill: #3fbc92;
}
.cls-3 {
  fill: #1c99ef;
}
.cls-4 {
  fill: #286289;
}
.cls-5 {
  fill: #003b4f;
}
</style>


// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-partial-logo-icon.vue